import React, { useState, useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";
import FieldLabel from "../../../components/Fields/FieldLabel";
import ItemRevisionColorModel from "../../../models/ItemRevisionColorModel";
import ItemRevision_popup_AddColor from "../Popups/ItemRevision_popup_AddColor";
import ItemColorControl from "./ItemColorControl";

interface IProps {
    onAdd: (colors?: ItemRevisionColorModel[]) => void
    onItemColorClick: (itemColor: ItemRevisionColorModel) => void
    itemColors: ItemRevisionColorModel[]
    itemRevisionId: number
    showAddButton: boolean
}

const ItemColorField: React.FC<IProps> = ({ onAdd, onItemColorClick, itemColors, itemRevisionId, showAddButton }) => {
    const [showAddColorPopup, setShowAddColorPopup] = useState(false)
    const [itemRevisionColors, setItemRevisionColors] = useState(itemColors)

    useEffect(() => {
        setItemRevisionColors(itemColors)
    }, [itemColors])

    var labelSize = 2

    function hidePopup(addedItemColors?: ItemRevisionColorModel[]) {
        setShowAddColorPopup(false)
        if (addedItemColors)
            onAdd(addedItemColors)
    }

    return (
        <>
            <Form.Group as={Row} className="form-field">
                <FieldLabel text={'Colors'} required={false} labelSize={labelSize} style={{ lineHeight: '22px' }} />
                <Col sm={12 - labelSize} style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                    {itemRevisionColors.map(color => <ItemColorControl itemColor={color} onClick={onItemColorClick} key={color.concurrencyId} />)}
                    {showAddButton && < div className='item-color' onClick={() => setShowAddColorPopup(true)}>+</div>}
                </Col>
            </Form.Group>
            {showAddColorPopup && <ItemRevision_popup_AddColor show={showAddColorPopup} onHide={hidePopup} itemRevisionId={itemRevisionId} />}
        </>
    );
}
export default ItemColorField;
